/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Item de la liste admin des produits.
 * @export
 * @interface ProduitAdminListItem
 */
export interface ProduitAdminListItem {
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    id: string;
    /**
     * Code (identifiant) du produit
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    code: string;
    /**
     * Libellé
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    branchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    branchLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    subBranchLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    ownerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    ownerName?: string | null;
    /**
     * Contrats En cours
     * @type {number}
     * @memberof ProduitAdminListItem
     */
    activeContractsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ProduitAdminListItem
     */
    quotesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProduitAdminListItem
     */
    isTacitRenewal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProduitAdminListItem
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProduitAdminListItem
     */
    logoURL?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProduitAdminListItem
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProduitAdminListItem
     */
    lastModificationDate?: Date | null;
}

/**
 * Check if a given object implements the ProduitAdminListItem interface.
 */
export function instanceOfProduitAdminListItem(value: object): value is ProduitAdminListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('isTacitRenewal' in value) || value['isTacitRenewal'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    return true;
}

export function ProduitAdminListItemFromJSON(json: any): ProduitAdminListItem {
    return ProduitAdminListItemFromJSONTyped(json, false);
}

export function ProduitAdminListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProduitAdminListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'branchLabel': json['branchLabel'] == null ? undefined : json['branchLabel'],
        'subBranchLabel': json['subBranchLabel'] == null ? undefined : json['subBranchLabel'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ownerName': json['ownerName'] == null ? undefined : json['ownerName'],
        'activeContractsCount': json['activeContractsCount'],
        'quotesCount': json['quotesCount'],
        'isTacitRenewal': json['isTacitRenewal'],
        'isActive': json['isActive'],
        'logoURL': json['logoURL'] == null ? undefined : json['logoURL'],
        'creationDate': (new Date(json['creationDate'])),
        'lastModificationDate': json['lastModificationDate'] == null ? undefined : (new Date(json['lastModificationDate'])),
    };
}

export function ProduitAdminListItemToJSON(json: any): ProduitAdminListItem {
    return ProduitAdminListItemToJSONTyped(json, false);
}

export function ProduitAdminListItemToJSONTyped(value?: ProduitAdminListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'branchId': value['branchId'],
        'branchLabel': value['branchLabel'],
        'subBranchLabel': value['subBranchLabel'],
        'ownerId': value['ownerId'],
        'ownerName': value['ownerName'],
        'activeContractsCount': value['activeContractsCount'],
        'quotesCount': value['quotesCount'],
        'isTacitRenewal': value['isTacitRenewal'],
        'isActive': value['isActive'],
        'logoURL': value['logoURL'],
        'creationDate': ((value['creationDate']).toISOString()),
        'lastModificationDate': value['lastModificationDate'] == null ? undefined : ((value['lastModificationDate'] as any).toISOString()),
    };
}

